import api, { apiPrefix } from './Api';
import {
  PopularCategory,
  popularCategoryFromResponse,
} from '../interfaces/Category/PopularCategory';

const popularCategoryApiPrefix = `${apiPrefix}/popular-categories`;

export const getPopularCategories = async (): Promise<PopularCategory[]> => {
  const response = await api.get(popularCategoryApiPrefix);

  return (response.data?.data ?? []).map(popularCategoryFromResponse);
};
